import dayjs from "dayjs";

import type { ReportingSummaryRow } from "./reportingSummaryTypes";

export type ReportingSummarySortKey =
  | "date"
  | "acceptedBets"
  | "acceptedTurnover"
  | "avgStake"
  | "pl"
  | "margin";

/** Client-side sort for reporting summary rows (analytics API has no server-side sort params in V1). */
export function sortReportingSummaryRows(
  rows: ReportingSummaryRow[],
  field: ReportingSummarySortKey | null | undefined,
  order: "ascend" | "descend" | null | undefined,
): ReportingSummaryRow[] {
  if (!field || !order) return [...rows];
  const mul = order === "ascend" ? 1 : -1;
  return [...rows].sort((a, b) => {
    if (field === "date") {
      const ta = a.date ? dayjs(a.date).valueOf() : 0;
      const tb = b.date ? dayjs(b.date).valueOf() : 0;
      if (ta === tb) return 0;
      return ta > tb ? mul : -mul;
    }
    const na = Number(a[field]);
    const nb = Number(b[field]);
    if (Number.isFinite(na) && Number.isFinite(nb) && na !== nb) {
      return na > nb ? mul : -mul;
    }
    return 0;
  });
}
